import { AppData, Img, Lightning, Utils } from '@lightningjs/sdk'
import { textures } from '../../build/lib/lightning.es5'
import { Helper } from '../lib/helper'
import { ItemNode } from "../lib/components/grid/ItemNode"
import StarUI from './star-ui'
import { AppSetup } from '../lib/app-setup'
import { Theme } from './info-ui'
import { Badge, TextBox } from '@lightningjs/ui-components'

export interface ResumeInfoUITemplateSpec extends Lightning.Component.TemplateSpec {
  NodeImg: object
  ImageWrapper: object
  background: string
  item: ItemNode
}

export default class ResumeInfoUI
  extends Lightning.Component<ResumeInfoUITemplateSpec>
  implements Lightning.Component<ResumeInfoUITemplateSpec>
{
  _theme: Theme = {};
  NodeImg = this.getByRef('NodeImg')!
  ImageWrapper = this.getByRef('ImageWrapper')!
  private _focusAnimation: Lightning.types.Animation | undefined = undefined

  static override _template(): Lightning.Component.Template<ResumeInfoUITemplateSpec> {
    return {
      ...super._template(),
      NodeImg: {
        w: 1920,
        h: 1080,
        x: 1920,
        y: 0,
        mountX: 1,
        src: '',
      },
      ImageWrapper: {
        x: 0,
        y: 0,
        w: 1920,
        h: 1080,
        rect: true,
        //colorTop: 0xff000000,
        //colorBottom: 0xff00000,
        colorLeft: 0xff0e0e1e,
        colorRight: 0x9f0e0e1e,
      },
      BackButton: {
          collision: true,
          x: 100,
          y: 92,
          alpha: 0.7,
          zIndex: 61,
          action: "$back",
          texture: {
              src: Utils.asset('images/ico-back.png'),
              resizeMode: {
                  h: 40,
                  w: 40,
                  type: 'contain',
              },
              type: Lightning.textures.ImageTexture
          }
      },
      Logo: { x: 163, y: 80},
      InfoTextWrapper: {
        x: 163,
        y: 150,
        flex: { direction: 'column'},
        Title: { text: { text: '', fontSize: 50, fontFace: Helper.getFontFamily('Black'), wordWrapWidth: 1500, textOverflow: "ellipsis", wordWrap:false} },
        ItemMetadataWrapper: {
          flexItem:{ marginTop: 0 },
          flex: { direction: 'row', wrap: false },
          rect: true, color: 0x00000000,
          children: []
        },
        Actors: { flexItem:{ marginTop: 20 }, alpha: 0, x: 0, text: { text: 'ACTORS', textColor: 0xffffffff, fontSize: 26, fontFace: Helper.getFontFamily('Regular'), letterSpacing : 1.5, wordWrapWidth: 1000, maxLines: 2, textOverflow: 'ellipsis' } },
        Directors: { flexItem:{ marginTop: 20 }, alpha: 0, x: 0, text: { text: 'DIRECTORS', textColor: 0xffffffff, fontSize: 26, fontFace: Helper.getFontFamily('Regular'),letterSpacing : 1.5, wordWrapWidth: 1000, maxLines: 2, textOverflow: 'ellipsis'  } },
        Description: {
            flexItem:{ marginTop: 20 },
            x: 0,
            Text : {
                w:1700,
                type: TextBox,
                fixed: true,
                content : '',
                contentWrap: true,
                style: {
                  textStyle: {
                    maxLines: 7,
                    maxLinesSuffix: '...More',
                    fontSize: 26,
                    fontFace: Helper.getFontFamily('Regular'),
                    wordWrapWidth: 1000
                  }
                }
            }
        },
      }
    }
  }

  _updateLogo() {
    const {appState} =  AppData as AppSetup
    const appApiConfig = appState?.getAppApiConfig()
    this.patch({
      Logo: {
        texture: {
          src: appApiConfig?.appBrandConfig?.header_logo,
          resizeMode: {
            h: 60,
            w: 460,
            type: 'contain',
          },
          type: Lightning.textures.ImageTexture
        },
      }
    })
  }

  override _init() {
    const image = this.tag('NodeImg')
    image?.on('txLoaded', () => {
      image.setSmooth('alpha', 1)
    })
    const { appState } = AppData as AppSetup
    const app = appState?.getApp();
    this._theme = (app?.themesObj as Theme) || {};
    const appApiConfig = appState?.getAppApiConfig()
    this._theme.ageRatingColor= `0xff${appApiConfig?.appConfig?.ageRatingColor}` || '0xffffffff'
  }

  set background(url: string) {
    /*this.patch({
      ImageWrapper: {
        texture: Img(url).contain(1920, 1080),
      },
    })*/
  }

  isDisplayActAndDir=false;
  set displayActAndDir(display: any) {    
    this.isDisplayActAndDir = display
  }

  getPatchObjects(item: ItemNode): any {
    const { appState } = AppData as AppSetup
    const appApiConfig = appState?.getAppApiConfig()
    const bgcolor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.bgcolor)
    const infoObj: any = {
      Title: { text: item.title },
      ItemMetadataWrapper: {
        children: [],
        visible:false
      },
      Actors: {
        alpha: 0,
        text: { text: ''},
        visible:false
      },
      Directors: {
        alpha: 0,
        text: { text: ''},
        visible:false
      },
      Description: {
        Text: { content: item.description },
      },
    }


    const releaseDate = item.release_date
    const runtimeAlpha = (item.runtime == 0 ? 0 : 1)
    const ageRatingAlpha = (item.age_appropriate_rating == '' ? 0 : 1)
    const popularityRatingAlpha = (item.popularity_rating == -1 ? 0 : 1)
    const actorsAlpha = (item.actors == null ? 0 : 1)
    const directorsAlpha = (item.directors == null ? 0 : 1)
    let metavisible = false;
    if (runtimeAlpha == 1 || ageRatingAlpha == 1 || popularityRatingAlpha == 1) {
      metavisible = true;
    }
    infoObj.ItemMetadataWrapper = {
      children: [],
      visible: metavisible
    }
    if (releaseDate !== '') {
      infoObj.ItemMetadataWrapper.children.push({
          h: 40,
          flexItem: { marginRight: 40 },
          text: { alpha:0.5, text: releaseDate, fontSize: 28, fontFace: Helper.getFontFamily('Light'), textColor: 0xffffffff },
      })
    }
    if (runtimeAlpha == 1) {
      infoObj.ItemMetadataWrapper.children.push({
        h:40,
        alpha: 0.7,
        flexItem: { marginRight: 40 },
        text: { alpha:0.5, text: Helper.secondsToHms(item.runtime), fontSize: 28, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff },
      })
    }
    if (ageRatingAlpha == 1) {
      infoObj.ItemMetadataWrapper.children.push({
        h:40,
        flexItem: { marginRight: 40 },
        type: Badge,
        title: item.age_appropriate_rating, style: { offsetY: 2, paddingX: 30, backgroundColor: bgcolor, radius: 0, textStyle: { fontSize: 22, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff } }
      })
    }
    if (popularityRatingAlpha == 1) {
      infoObj.ItemMetadataWrapper.children.push({
        h:40,
        y: -5,
        alpha: popularityRatingAlpha,
        type: StarUI,
        rating: item.popularity_rating,
      })
    }    
    if(this.isDisplayActAndDir){
      let actorsVisible = false;
      let directorsVisible = false;
      if (actorsAlpha == 1) {
        actorsVisible = true;
      }
      if (directorsAlpha == 1) {
        directorsVisible = true;
      }
      if (actorsAlpha == 1) {
        infoObj.Actors = {
          alpha: actorsAlpha,
          text: { text: 'Cast: ' + item.actors, fontSize: 24, fontFace: Helper.getFontFamily('Regular') },
          visible: actorsVisible
        }
      }
      if (directorsAlpha == 1) {
        infoObj.Directors = {
          alpha: directorsAlpha,
          text: { text: 'Direction: ' + item.directors, fontSize: 24, fontFace: Helper.getFontFamily('Regular') },
          visible: directorsVisible
        }
      }
    }
    

    return infoObj
  }

  set item(item: ItemNode) {
    if (!item) return;
    this._updateLogo()
    this.patch({
      InfoTextWrapper: this.getPatchObjects(item),
      NodeImg: {
        src: item.bg_image_landscape,
      },
    })
  }

  override _firstActive() {
    //this._update()
  }

  override _focus() {
    if (this._focusAnimation) {
      this._focusAnimation.start()
    }
  }

  override _unfocus() {
    this._focusAnimation?.stop()
  }

  static get width() {
    return 400
  }

  static get height() {
    return 600
  }
}
